import { render } from "./SapgCustomAdmin.vue?vue&type=template&id=b9ebdac4"
import script from "./SapgCustomAdmin.vue?vue&type=script&lang=js"
export * from "./SapgCustomAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__